/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="wrapp-minicart sidebar-block-panel">
    <div class="sidebar-block-content">
      <div class="sidebar-block-content__header">
        <div class="wrapp-title">
          <cart-badge :itemCount="productCount" :useRoundedIcon="false" />
          <div class="text">
            <span>{{ $t('shopping-bag') }}</span>
          </div>
        </div>
        <div class="wrapp-icon">
          <button class="cta btn btn-none" @click.prevent="closeMiniCart">
            <svg class="o-icon stroke-black"><use xlink:href="#close"></use></svg>
          </button>
        </div>
      </div>
      <template v-if="products.length">
        <div class="sidebar-block-content__body">
          <div class="wrapp-product-list">
            <no-ssr>
              <overlay-scrollbars class="wrapp-product-list-list" :options="{className: 'os-theme-minimal-light'}">
                <div class="product-list">
                  <mini-cart-product
                    v-for="(product, index) in products"
                    :key="product.sku"
                    :product="product"
                    @confirm-removal="openModalConfirm(index)"
                    ref="cartProduct"
                  />
                  <modal-confirm
                    @updateModalConfirm="closeModalConfirm"
                    :modal-show="toggleModalConfirm"
                    :message="$t('messageRemoveCartProduct')"
                    @cancel="closeModalConfirm"
                    @confirm="confirmDelete"
                  />
                </div>
              </overlay-scrollbars>
            </no-ssr>
            <Summary :showCartBtn="false" :showPaymentBtn="false" :showCheckoutBtn="false"></Summary>
          </div>
        </div>
        <div class="sidebar-block-content__footer">
          <button class="cta btn btn-icon-text-out" @click.prevent="removeAll">
            <svg class="o-icon"><use xlink:href="#circle-close"></use></svg>
            <span class="text">{{ $t('remove-all') }}</span>
          </button>
          <!-- click-to-checkout -->
          <router-link :to="{ name: 'onepagecheckout' }" class="btn btn-primary btn-primary-large btn-primary-black btn-rounded btn-primary-with-icon" @click.native="hideNavigations()">
            <span class="text">{{ $t('proceed-to-checkout') }}</span>
            <svg class="o-icon fill-white"><use xlink:href="#arrow-right-short"></use></svg>
          </router-link>
        </div>
      </template>
      <div v-else class="empty-cart">
        <p class="top-message">{{$t('no-items-on-shopping-bag')}}</p>
      </div>
    </div>
    <AbsoluteLoader :showLoader="loader"></AbsoluteLoader>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '@/helpers'
import MiniCartProduct from 'theme/components/Cart/MiniCartProduct'
import Summary from 'theme/components/Checkout/Cart/Summary'
import CartBadge from 'theme/components/Header/CartBadge'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'
import ModalConfirm from 'theme/components/Modal/ModalConfirm'

export default {
  name: 'MiniCart',
  data () {
    return {
      productIndex: false, // STORE THE PRODUCT INDEX IN LIST TO ACCESS AT REF
      toggleModalConfirm: false
    }
  },
  computed: {
    ...mapState({
      products: state => state.cart.items,
      showMiniCart: state => state.ui.showMiniCart,
      loader: state => state.ui.loader
    }),
    productCount () {
      return this.$store.getters['cart/badge']
    }
  },
  methods: {
    closeMiniCart () {
      EventBus.$emit('BottomNavigation:closeNav', true)
    },
    removeAll () {
      if (this.$refs.cartProduct) {
        this.$store.commit('ui/showLoader')
        this.$refs.cartProduct.forEach((el) => {
          return el.remove()
        })
        this.$store.commit('ui/hideLoader')
        // this.$route.push({ name: 'home' })
      }
    },
    openModalConfirm ($event) {
      this.productIndex = $event
      this.toggleModalConfirm = true
    },
    closeModalConfirm () {
      this.toggleModalConfirm = this.productIndex = false
    },
    confirmDelete () {
      if (this.$refs.cartProduct) {
        let products = this.$refs.cartProduct
        if (products && products[this.productIndex]) {
          products[this.productIndex].remove()
          this.closeModalConfirm()
        }
      }
      return true
    },
    hideNavigations () {
      this.$store.commit('ui/setBottomActiveComponent', {})
    }
  },
  components: {
    MiniCartProduct,
    Summary,
    CartBadge,
    AbsoluteLoader,
    ModalConfirm
  }
}
</script>
